import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ui-input__borders" }, null, -1)
const _hoisted_2 = { class: "ui-input__container ui-input__container--file" }
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("U")
const _hoisted_5 = ["id", "name", "disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Открыть")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "ui-input__label"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-input__borders" }, null, -1)
const _hoisted_10 = { class: "ui-input__container" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["id", "type", "value", "placeholder", "disabled"]
const _hoisted_14 = {
  key: 0,
  class: "ui-input__options"
}
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-input", [_ctx.computedClass, _ctx.disabled && 'ui-input--disabled']]),
    ref: "refRoot",
    style: _normalizeStyle({..._ctx.computedStyle, ..._ctx.style}),
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_ctx.type === 'file')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", { for: _ctx.inputId }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
              _createVNode(_component_Btn, { class: "ui-input__label-btn" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ], 8, _hoisted_3),
            _createElementVNode("input", {
              type: "file",
              id: _ctx.inputId,
              name: _ctx.name,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event))),
              disabled: _ctx.disabled,
              ref: "refInput"
            }, null, 40, _hoisted_5),
            _createVNode(_component_Btn, {
              class: "ui-input__file-btn",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("label", _hoisted_7, [
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("img", { src: _ctx.searchIcon }, null, 8, _hoisted_11), [
              [_vShow, _ctx.search && _ctx.clear && !_ctx.modelValue]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _ctx.clearIcon,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clearSearch')))
            }, null, 8, _hoisted_12), [
              [_vShow, _ctx.clear && _ctx.modelValue]
            ]),
            _createElementVNode("input", {
              ref: "refInput",
              id: _ctx.inputId,
              type: _ctx.type,
              value: _ctx.modelValue,
              placeholder: _ctx.placeholder,
              disabled: _ctx.disabled,
              style: _normalizeStyle({..._ctx.search && {'padding-right': '4rem'}}),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFocus())),
              autocomplete: "off"
            }, null, 44, _hoisted_13)
          ])
        ])),
    (_ctx.useOptions)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.options$?.display && _ctx.options$?.rows.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options$?.rows, (row) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "ui-input__options-item",
                    href: "#",
                    onClick: _withModifiers(($event: any) => {_ctx.$emit('update:selectedRow', row); _ctx.options$ && (_ctx.options$.display = false)}, ["prevent"])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(row?.name || row?.value || row), 1)
                  ], 8, _hoisted_15))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 6))
}